import api from "../apiapp";


const portfolioManagerService = {
    getPortfolioManagers: async function () {
        const response = await api.request({
          url: "/portfolio-managers?page[size]=50",
          method: "GET",
        })

        return response.data
    },
    getPortfolioManagerSearch: async function (model) {
      var filters = '';
      if(model.email !== ""){ filters += '&filter[email]='+model.email; }
      if(model.name !== ""){ filters += '&filter[name]='+model.name; }
      if(model.role !== ""){ filters += '&filter[role]='+model.role; }
        
        const response = await api.request({
          // url: "/users?include=statementSignatures,roles&sort=name&page[size]=30&filter[active]=1"+filters,
          url: "/portfolio-managers?include=roles&sort=name&page[size]=30&filter[active]=1"+filters,
          method: "GET",
        })
    
        return response.data
    },
    getPortfolioManagerSearchPagination: async function (url) {
      const response = await api.request({
        url: url,
        method: "GET",
      })
  
      return response.data
  },
    

}
  
export default portfolioManagerService;